import { useState } from 'react';
import useEventListener from './use-event-listener';

interface ColumnDragState {
    isDraggingColumn: boolean;
}

export function useColumnDragState(): ColumnDragState {
    const [isDraggingColumn, setIsDragging] = useState(false);

    const blockScroll: EventListener = (evt: Event): void => {
        evt.preventDefault();
        evt.stopPropagation();
        setIsDragging(true);
    };

    const enableScroll: EventListener = (evt: Event): void => {
        evt.preventDefault();
        evt.stopPropagation();
        setIsDragging(false);
    };

    useEventListener('drag', blockScroll, undefined, { passive: false });
    useEventListener('dragend', enableScroll, undefined, { passive: false });

    return { isDraggingColumn };
}
